<template>
    <div>
        <form @submit.prevent="on_submit" id="submit_form">
            <div class="row">
                <div class="col-12 my-2">
                    <div class="h5" v-text="$t('wallets.label.settlement')"></div>
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="password" v-text="$t('label.wallet_password')"></label>
                    <input class="form-control" type="password" id="password" name="password" v-model="password.value">
                </div>

                <div v-for="(item, index) in form_data" :key="index">
                    <div class="row border border-success m-2 px-2 pb-4">
                        <div class="col-12">
                            <div class="text-danger ml-auto"
                                 style="cursor: pointer; width: fit-content;"
                                 @click="deleteRow(index)"
                            >
                                <i class="fas fa-trash"></i>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mb-2">
                            <label :for="`transfers.${index}.amount`" v-text="$t('label.amount_rial')"></label>
                            <amount-input
                                    :item_id="`transfers.${index}.amount`"
                                    :item_name="`transfers.${index}.amount`"
                                    :item="form_data[index]"
                            ></amount-input>
                        </div>

                        <div class="col-12 col-md-6 mb-2">
                            <label :for="`transfers.${index}.destination_number`" v-text="$t('label.destination_number')"></label>
                            <input class="form-control transfers_destination_number"
                                   :id="`transfers.${index}.destination_number`"
                                   :name="`transfers.${index}.destination_number`"
                                   type="text"
                                   dir="ltr"
                                   @keyup="checkIban(form_data[index].destination_number, index)"
                                   @change="checkIban(form_data[index].destination_number, index)"
                                   v-model="form_data[index].destination_number"
                            >
                            <small class="text-info">{{getBankNickname(form_data[index].destination_number)}}</small>
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label :for="`transfers.${index}.destination_firstname`" v-text="$t('label.destination_firstname')"></label>
                            <input class="form-control"
                                   :id="`transfers.${index}.destination_firstname`"
                                   :name="`transfers.${index}.destination_firstname`"
                                   type="text"
                                   v-model="form_data[index].destination_name"
                            >
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label :for="`transfers.${index}.track_id`" v-text="`${$t('label.track_id')} (${$t('label.optional')})`"></label>
                            <input class="form-control"
                                   :id="`transfers.${index}.track_id`"
                                   :name="`transfers.${index}.track_id`"
                                   type="text"
                                   v-model="form_data[index].track_id"
                            >
                        </div>
                        <div class="col-12 col-md-6 my-2">
                            <label :for="`transfers.${index}.payment_id`" v-text="`${$t('label.payment_id')} (${$t('label.optional')})`"></label>
                            <input class="form-control"
                                   :id="`transfers.${index}.payment_id`"
                                   :name="`transfers.${index}.payment_id`"
                                   type="number"
                                   v-model="form_data[index].payment_id"
                            >
                            <small class="text-info">این فیلد مخصوص حساب های شناسه دار می باشد.
                            </small>
                        </div>
                        <div
                            v-if="canHaveInstitutionId(form_data[index].destination_number)"
                            class="col-12 col-md-6 my-2"
                            :id="`${index}.institution_id.div`"
                        >
                            <label :for="`transfers.${index}.institution_id`"
                                   v-text="`${$t('wallets.label.institution_id')}  (${$t('label.optional')})`">
                            </label>
                            <input :id="`transfers.${index}.institution_id`"
                                   :name="`transfers.${index}.institution_id`"
                                   class="form-control"
                                   type="text"
                                   v-model="form_data[index].institution_id"
                            >
                            <small class="text-info">این فیلد مخصوص حساب های شناسه دار سامان می باشد.</small>
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-5 pt-5">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center justify-content-between">
                            <button class="btn btn-primary mx-2"
                                    type="button"
                                    v-text="$t('label.add_new_record')"
                                    @click="addRow()"
                            >
                            </button>
                            <div class="d-inline-block mx-2">
                                <select id="new_shareholder"
                                        name="new_shareholder"
                                        v-model="new_shareholder"
                                        class="form-control"
                                >
                                    <option :value="null" selected disabled v-text="$t('label.add_new_shareholder')"></option>
                                    <option v-for="(shareholder, index) in shareholders"
                                            :key="index"
                                            :value="shareholder"
                                            v-text="shareholder.first_name + ' ' + shareholder.last_name"
                                    ></option>
                                </select>
                            </div>
                            <div v-if="new_shareholder !== null"
                                 class="d-inline-block mx-2"
                            >
                                <select id="new_account_number"
                                        name="new_account_number"
                                        v-model="new_account_number"
                                        class="form-control"
                                >
                                    <option :value="null" selected disabled v-text="$t('label.add_new_account_number')"></option>
                                    <option v-for="(account_number, index) in new_shareholder.account_numbers"
                                            :key="index"
                                            :value="account_number"
                                            v-text="account_number"
                                    ></option>
                                </select>
                            </div>
                        </div>
                        <div v-if="should_two_factor_settlement">
                            <button class="btn btn-success ml-auto"
                                    type="submit"
                                    v-text="$t('btn.send_code')"
                            ></button>
                        </div>
                        <div>
                            <button class="btn btn-success ml-auto"
                                    type="submit"
                                    v-text="$t('wallets.btn.create_settlement_request')"
                            ></button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <otp-modal
            :loading="form_meta_data.submit_btn_progress"
            :message="$t('label.input_verification_code')"
            :two_factor_type="form_data.two_factor_type"
            @emitAction="setOtp"
            @sendRequest="sendRequest"
        />
    </div>
</template>

<script>
    import Inputmask from 'inputmask';
    import {i18n} from "@/plugins/i18n";
    import {walletService} from "@/common/api.service";
    import IranSheba from "iran-sheba";
    import AmountInput from "@/components/custom-elements/amount-input";
    import $ from 'jquery';
    import otpModal from "@/components/elements/modal/otp-modal.vue";
    import {TwoFactorType} from "@/constants/TwoFactorType";
    import Axios from "axios";


    export default {
        components: {AmountInput, otpModal},
        data() {
            return {
                shareholders: [],
                new_shareholder: null,
                new_account_number: null,
                should_two_factor_settlement: false,
            };
        },
        watch: {
            new_account_number(value) {
                if (value === null) {
                    return;
                }

                // if last record is empty, fill it. otherwise add new record
                if (this.form_data[this.form_data.length - 1].destination_number === ''
                    && this.form_data[this.form_data.length - 1].destination_firstname === ''
                    && this.form_data[this.form_data.length - 1].destination_lastname === ''
                ) {
                    this.form_data[this.form_data.length - 1].destination_number = this.new_account_number;
                    this.form_data[this.form_data.length - 1].destination_firstname = this.new_shareholder.first_name;
                    this.form_data[this.form_data.length - 1].destination_lastname = this.new_shareholder.last_name;
                } else {
                    this.form_data.push({
                        amount: '',
                        destination_number: this.new_account_number,
                        destination_firstname: this.new_shareholder.first_name,
                        destination_lastname: this.new_shareholder.last_name,
                    });
                }

                this.new_account_number = null;
                this.new_shareholder = null;
            },
            transfer_length() {
                setTimeout(() => {
                    this.initShebaMask();
                }, 500);
            },
        },
        computed: {
            transfer_length() {
                return this.form_data.length;
            },
        },
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {},
            },
            form_data: Array,
            password: Object,
        },
        mounted() {
            this.initShebaMask();
            walletService.shareholderList().then(res => {
                this.shareholders = res.data.data;
            });

            Axios.get('wallet/common?wallet_prefix=A').then(response => {
                response.data.data.forEach(wallet => {
                    if (wallet.id === this.$route.params.hashid) {
                        this.should_two_factor_settlement = wallet.should_two_factor_settlement;
                        this.form_data.should_two_factor_settlement = wallet.should_two_factor_settlement;
                    }
                })
            });
        },
        methods: {
            sendRequest(type) {
                this.form_data.two_factor_type = type;
                if (type === TwoFactorType.SMS) this.on_submit()
            },
            setOtp(data) {
                this.form_data.otp = data;
                this.$emit('settlement')
            },
            canHaveInstitutionId(sheba){
                return this.getBankNickname(sheba) === 'بانک سامان'
            },
            getBankNickname(sheba) {
                sheba = sheba.replace(/[\-_ ]/g, '')
                const bank = IranSheba.recognize(sheba);
                if (bank) {
                    return bank.persianName;
                }
                return ""; // default value for when this function failed to recognize the bank name
            },
            checkIban(iban, index) {
                iban = iban.replace(/[\-_ ]/g, '');

                if (! this.isValidIban(iban)) {
                    return;
                }

                $('#submit_button').focus();

                let params = {
                    iban: iban,
                };

                let hashid = this.$route.params.hashid;
                walletService.getIbanInfo(params, hashid).then(res => {

                    let data = res.data.data;
                    this.form_data[index].destination_name = data.first_name + ' ' + data.last_name;
                    this.$forceUpdate();
                });
                if (this.getBankNickname(iban) === 'بانک سامان') {
                    this.$forceUpdate();
                }
            },
            isValidIban(iban) {
                iban = iban.replace(/[\-_ ]/g, '');

                if (iban.length !== 26) { // 26 with IR
                    return false;
                }

                return IranSheba.isValid(iban);
            },
            deleteRow(index) {
                if (this.form_data.length < 2) {
                    return;
                }

                this.form_data.splice(index, 1);
            },
            addRow() {
                if (this.form_data.length > 100) {
                    return;
                }

                this.form_data.push({
                    amount: '',
                    destination_number: '',
                    destination_firstname: '',
                    destination_lastname: '',
                });
            },
             initShebaMask() {
                Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.transfers_destination_number'));
            },
        }
    }
</script>
